import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Twitch, Youtube } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-surface border-t border-border mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 w-full" style={{display: 'grid', gridTemplateColumns: '1fr', gap: '2rem'}}>
          {/* Left Section - Branding & Social */}
          <div className="lg:col-span-2 flex flex-col items-center lg:items-start">
            <div className="flex items-center mb-6">
              <img 
                src="/images/Just_Vibes_Logo_-_No_Background.png" 
                alt="Just Vibes Logo" 
                className="logo-footer"
              />
            </div>
            <p className="text-text-secondary mb-8 text-center lg:text-left max-w-md">
              Professional World of Warcraft guild focused on competitive raiding, 
              community building, and creating lasting friendships in Azeroth.
            </p>
            <div className="flex space-x-4 mb-8">
              <button
                className="social-button"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </button>
              <button
                className="social-button"
                aria-label="Twitch"
              >
                <Twitch size={20} />
              </button>
              <button
                className="social-button"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </button>
            </div>
          </div>

          {/* Right Section - Navigation Columns */}
          <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Quick Links Column */}
            <div className="flex flex-col items-center md:items-start">
              <h3 className="text-lg font-semibold mb-6 text-text-primary uppercase tracking-wide">Navigation</h3>
              <ul className="space-y-3 text-center md:text-left">
                <li>
                  <Link to="/" className="footer-link">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="footer-link">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/roster" className="footer-link">
                    Roster
                  </Link>
                </li>
                <li>
                  <Link to="/progress" className="footer-link">
                    Progress
                  </Link>
                </li>
                <li>
                  <Link to="/recruitment" className="footer-link">
                    Recruitment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Guild Info Column */}
            <div className="flex flex-col items-center md:items-start">
              <h3 className="text-lg font-semibold mb-6 text-text-primary uppercase tracking-wide">Who We Are</h3>
              <ul className="space-y-3 text-center md:text-left">
                <li>
                  <Link to="/about" className="footer-link">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/roster" className="footer-link">
                    Our Team
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="footer-link">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* WoW Specific Column */}
            <div className="flex flex-col items-center md:items-start">
              <h3 className="text-lg font-semibold mb-6 text-text-primary uppercase tracking-wide">Warcraft</h3>
              <ul className="space-y-3 text-center md:text-left">
                <li>
                  <Link to="/progress" className="footer-link">
                    Raid Progress
                  </Link>
                </li>
                <li>
                  <Link to="/roster" className="footer-link">
                    Raid Team
                  </Link>
                </li>
                <li>
                  <button className="footer-link">
                    Apply Now
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center">
          <p className="text-text-muted">
            © {currentYear} Just Vibes. All rights reserved. World of Warcraft is a trademark of Blizzard Entertainment.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 